export const PAGE_LABELS = {
	LOADING: 'Loading labels...',
	ERROR: 'Failed to load labels. Please try again.'
} as const;
